import React, { RefObject, useEffect, useState } from "react";
import EditAndUploadToHubModal from "../../../components/widgets/EditAndUploadToHubModal";
import { Video } from "../../../common/video/models/Video";
// import VideoReactions from "../../../viewer/videoPlayer/components/player/reactions/VideoReactions";
import styles from "./VideoPlayerWithSubs.module.css";
import "./reactPdf.css";
import { ExtractExtention } from "../../../utils/ObjectUtils";
import { useInitText } from "../../../components/function/useInitText";
import { MoreVert } from "@material-ui/icons";
import VideoMenu from "../../../common/components/videoMenu/VideoMenu";
import PuiMessage from "../../../components/widgets/PuiMessage";
import PuiTypography from "../../../components/elements/PuiTypography";
import { ShowVideoAdminBtn, HideVideoAdminBtn, isEditor, isAdmin } from "../../../utils/LogicUtils";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";

interface VideoPlayerWithSubsProps {
    video: Video;
    videoRef: RefObject<HTMLVideoElement>;
    currentVideoTimeMs: number;
    track: string;
    setEditModalOpen: (target: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        menuItemText: {
            width: "178px",
            height: "32px",
            paddingTop: "4px",
            paddingLeft: "20px",
            backgroundColor: "#1E2329",
            "&:hover": {
                backgroundColor: "#35393F",
            },
        },
    })
);

function VideoPlayerWithSubs({
    video,
    videoRef,
    currentVideoTimeMs,
    track,
    setEditModalOpen,
}: VideoPlayerWithSubsProps) {
    const token = localStorage.getItem("cineonhub_access_token");

    const classes = useStyles();

    // ビデオURL
    const sourceUrl =
        process.env.REACT_APP_API_ENDPOINT +
        video.sourceUrl +
        "/" +
        ExtractExtention(video.fileName) +
        "?Authorization=" +
        token;

    // 動画再生するURL
    const [currentUrl, setCurrentUrl] = useInitText();

    const [isShowMore, setIsShowMore] = useState<boolean>(false);

    const [msg, setMsg] = useState<string>("");

    const closeMsg = () => {
        setMsg("");
    };

    // 動画ファイルのダウンロード
    const handleDownloadVideo = () => {
        let alink = document.createElement("a");
        alink.href = video.downloadUrl;
        alink.click();
    };

    // ユーザー取得
    const { user } = useSelector((state: AppState) => ({
        user: state.user.user,
    }));

    // 再生表示パターン切り替え時に再生時間を保持する
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.currentTime = Math.floor(currentVideoTimeMs / 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (currentUrl === "") {
            setCurrentUrl(sourceUrl);
        }
        // eslint-disable-next-line
    }, [sourceUrl]);

    if (!video) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <div className={styles.videoArea}>
                {/* ビデオ */}
                <video
                    id="videoPlayer"
                    className={
                        videoRef.current &&
                        videoRef.current.videoWidth / videoRef.current.videoHeight >= 1
                            ? styles.LandscapeVideo
                            : styles.PortraitVideo
                    }
                    controls
                    autoPlay
                    width="100%"
                    ref={videoRef}
                    key={currentUrl} // Needed to inform React of source changes.
                    style={{ display: "block" }}
                    onMouseEnter={ShowVideoAdminBtn}
                    onMouseLeave={HideVideoAdminBtn}
                    controlsList="nodownload"
                >
                    <source src={currentUrl} type="video/mp4" />
                    <track default={true} kind="subtitles" srcLang="ja" label="オン" src={track} />
                </video>

                {/* /* ビデオリアクション
                <VideoReactions
                    reactions={video.reactions}
                    videoId={video.id}
                    videoDuration={video.durationMillis}
                    videoRef={videoRef}
                /> */}

                {/* ビデオ編集ボタン */}
                {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                    <div
                        onClick={() => setIsShowMore(!isShowMore)}
                        className={styles.moreIcon}
                        id="videoAdminBtn"
                    >
                        <MoreVert />
                    </div>
                )}
                {(isAdmin(user?.roles) || isEditor(user?.roles)) && isShowMore && (
                    <div className={styles.menuItem}>
                        <div>
                            <EditAndUploadToHubModal video={video} showModal={setEditModalOpen} />
                        </div>
                        <div>
                            <VideoMenu
                                videoId={video.id ? video.id : 0}
                                setMsg={setMsg}
                                video={video}
                            />
                        </div>
                        <div className={classes.menuItemText} onClick={handleDownloadVideo}>
                            <PuiTypography size={14}>{t("ダウンロード")}</PuiTypography>
                        </div>
                    </div>
                )}
                <PuiMessage
                    open={msg !== ""}
                    type="success"
                    title="登録に成功しました"
                    detail={[
                        <PuiTypography key={msg} color="black">
                            {msg}
                        </PuiTypography>,
                    ]}
                    duration={5000}
                    onClose={closeMsg}
                />
            </div>
        </>
    );
}

export default VideoPlayerWithSubs;
